export const CATEGORY_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type CategoryShowTab = (typeof CATEGORY_SHOW_TABS)[number];

export const CATEGORY_DEFAULT_TAB: CategoryShowTab = 'general';
